module.exports = __webpack_public_path__ + "img/8.f077ee54.png";